import { createAsyncThunk } from "@reduxjs/toolkit";
import {
  createClaimantAdministratorAPI,
  updateClaimantAdministratorAPI,
  deleteClaimantAdministratorAPI,
  getClaimantAdministratorByCaseIDAPI,
  deleteClaimantAdministratorDocumentAPI,
} from "../../../api/claimantAdministrator_api";

// ============================================================================
// ASYNC THUNKS
// ============================================================================

export const getClaimantAdministratorByCaseIDAction = createAsyncThunk(
  "claimantAdministrator/getClaimantAdministratorByCase",
  async (caseID, { rejectWithValue }) => {
    const response = await getClaimantAdministratorByCaseIDAPI(caseID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const createClaimantAdministratorAction = createAsyncThunk(
  "claimantAdministrator/createClaimantAdministrator",
  async (claimantAdministratorData, { rejectWithValue }) => {
    const response = await createClaimantAdministratorAPI(
      claimantAdministratorData,
    );
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const updateClaimantAdministratorAction = createAsyncThunk(
  "claimantAdministrator/updateClaimantAdministrator",
  async (
    { claimantAdministratorID, claimantAdministratorData },
    { rejectWithValue },
  ) => {
    const response = await updateClaimantAdministratorAPI(
      claimantAdministratorID,
      claimantAdministratorData,
    );

    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteClaimantAdministratorAction = createAsyncThunk(
  "claimantAdministrator/deleteClaimantAdministrator",
  async (claimantAdministratorID, { rejectWithValue }) => {
    const response = await deleteClaimantAdministratorAPI(
      claimantAdministratorID,
    );
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);

export const deleteClaimantAdministratorDocumentAction = createAsyncThunk(
  "claimantAdministrator/deleteClaimantAdministratorDocument",
  async ({ documentID }, { rejectWithValue }) => {
    const response = await deleteClaimantAdministratorDocumentAPI(documentID);
    if (!response.success) {
      return rejectWithValue(response.error);
    }
    return response.data;
  },
);
